<template>
  <div class="ep-banner-list">
    <swiper ref="swiper" :options="mergeSwiperOptions" v-if="data.length > 0" v-once>
      <swiper-slide :key="index" v-for="(item, index) in data">
        <component :is="cardComponent" v-bind="item" :is-preview="isPreview" />
      </swiper-slide>
      <div class="swiper-button-prev swiper-button" slot="button-prev" role="button" aria-label="이전 슬라이드"></div>
      <div class="swiper-button-next swiper-button" slot="button-next" role="button" aria-label="다음 슬라이드"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div
      class="swiper-button"
      :class="isRunning ? 'swiper-button-pause' : 'swiper-button-play'"
      @click="toggleAutoplay"
      role="button"
      :aria-label="isRunning ? '배너 자동 롤링 일시정지' : '배너 자동 롤링 시작'"
    ></div>
  </div>
</template>

<script>
import { Autoplay, Mousewheel, Pagination, Navigation, Swiper as SwiperClass } from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.css";
import EpBannerItem from "@/components/mainbanner/EpBannerItem";
import EpBannerItemLoan from "@/components/mainbanner/EpBannerItemLoan";
import EpBannerItemInsurance from "@/components/mainbanner/EpBannerItemInsurance";

SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay]);
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);

export default /*#__PURE__*/ {
  name: "EpBannerList",
  components: {
    Swiper,
    SwiperSlide,
    EpBannerItem,
    EpBannerItemLoan
  },
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isPreview: {
      type: Boolean
    },
    cardType: {
      type: String,
      default: "" // loan: 추천 대출 상품 카드
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      swiper: null,
      videos: [],
      mergeSwiperOptions: {},
      swiperOptions: {
        simulateTouch: false, // PC Chrome > Mobile 이중 클릭 이슈로 인해 false 처리
        slideToClickedSlide: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        on: {
          init: this.initSwiper,
          click: this.clickSwiper,
          slideChangeTransitionEnd: this.slideChangeTransitionEnd,
          sliderFirstMove: this.swipeSlide
        },
        pagination: {
          el: ".swiper-pagination"
        },
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next"
        },
        a11y: {
          prevSlideMessage: "이전 슬라이드",
          nextSlideMessage: "다음 슬라이드"
        }
      },
      isRunning: true
    };
  },
  computed: {
    cardComponent() {
      switch (this.cardType) {
        case "loan":
          return EpBannerItemLoan;
        case "insurance":
          return EpBannerItemInsurance;
        default:
          return EpBannerItem;
      }
    }
  },
  methods: {
    initSwiper(swiper) {
      this.swiper = swiper;

      swiper.slides.forEach((element, index) => {
        const video = element.querySelector("video");

        if (video) {
          this.videos.push({ elVideo: video, slideIndex: index });
        }
      });

      const prevButtons = document.getElementsByClassName("swiper-button-prev");
      if (!prevButtons.length) console.error("slides - prev buttons are not created");

      for (let i = 0; i < prevButtons.length; i++) {
        prevButtons[i].onclick = () => {
          this.$emit("click-prev");
        };
      }

      const nextButtons = document.getElementsByClassName("swiper-button-next");
      if (!nextButtons.length) console.error("slides - next buttons are not created");

      for (let i = 0; i < nextButtons.length; i++) {
        nextButtons[i].onclick = () => {
          this.$emit("click-next");
        };
      }

      this.$emit("init-swiper", swiper);
    },

    enableSwiper() {
      if (!this.swiper) return;

      this.swiper.enable();
    },

    disableSwiper() {
      if (!this.swiper) return;

      this.swiper.disable();
    },

    clickSwiper(swiper) {
      const { slides, clickedIndex } = swiper;

      if (slides[clickedIndex]) {
        this.disableSwiper();
        this.$emit("click-slide", slides[clickedIndex].children[0]);
        setTimeout(() => {
          this.enableSwiper();
        }, 800);
      }
    },

    swipeSlide(swiper, event) {
      this.$emit("swipe", swiper, event);
    },

    slideChangeTransitionEnd(swiper) {
      const { activeIndex, realIndex } = swiper;

      this.$emit("change-active-index", swiper, activeIndex, realIndex);

      if (this.videos) {
        this.videos.forEach((element) => {
          const elVideo = element.elVideo;
          const isActiveVideoSlide = activeIndex === element.slideIndex;

          if (isActiveVideoSlide) {
            elVideo.currentTime = 0;
            elVideo.play();
          } else {
            elVideo.pause();
          }
        });
      }
    },

    toggleAutoplay() {
      if (!this.swiper) return;
      if (this.swiper.autoplay.running) {
        this.swiper.autoplay.stop();
        this.isRunning = false;
        this.$emit("stop-autoplay");
      } else {
        this.swiper.autoplay.start();
        this.isRunning = true;
        this.$emit("start-autoplay");
      }
    }
  },
  created() {
    this.mergeSwiperOptions = {
      ...this.swiperOptions,
      ...this.options
    };
  }
};
</script>

<style lang="scss">
.ep-banner-list {
  position: relative;

  .type {
    display: inline-block;
    margin: 6px 3px 0 0;
    font-size: 13px;
    color: #999;
    vertical-align: text-top;
  }

  .swiper-pagination {
    top: 20px;
    right: 41px;
    bottom: auto;
    left: auto;
    width: auto;
    text-align: right;

    &-bullet {
      width: 5px;
      height: 5px;
      background: #000;
      opacity: 0.2;
      vertical-align: top;

      &-active {
        opacity: 0.5;
      }
    }
  }

  .swiper-button {
    z-index: 10;
    background-size: contain;

    &.swiper-button-prev,
    &.swiper-button-next {
      width: 24px;
      height: 24px;

      &:after {
        content: none;
      }
    }

    &.swiper-button-prev {
      left: 1px;
      background-image: url("~@/assets/icons/icon-swiper-left@2x.png");
    }

    &.swiper-button-next {
      right: 1px;
      background-image: url("~@/assets/icons/icon-swiper-right@2x.png");
    }

    &.swiper-button-play,
    &.swiper-button-pause {
      z-index: 10;
      position: absolute;
      width: 16px;
      height: 16px;
      cursor: pointer;
      top: 15px;
      right: 20px;
    }

    &.swiper-button-play {
      background-image: url("~@/assets/icons/icon-swiper-play@2x.png");
    }

    &.swiper-button-pause {
      background-image: url("~@/assets/icons/icon-swiper-pause@2x.png");
    }
  }
}
</style>
